export enum PaymentAccountHolder {
  SAM = 'SAM',
  SPP = 'SPP',
}
